import { css, keyframes } from '@emotion/react'

export const checkboxContainerCss = (dcfChecked: boolean) => css`
  position: relative;
  background: rgba(243, 242, 242, 1);
  transition: all 0.4s;

  span {
    position: relative;
    z-index: 2;
  }

  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: ${dcfChecked ? '100%' : '0'};
    height: 100%;
    background: rgba(46, 125, 50, 0.12);
    transition: all 0.4s;
  }
`

const labelTextChangeAnimation = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const animatedLabelCss = css`
  &.fade-out {
    animation: ${labelTextChangeAnimation} 0.4s ease-in;
  }
`
